export const FUMICO_PHONE_NUMBER = "595994322104";
export const DEFAULT_PRODUCT_IMAGE =
  "https://upload.wikimedia.org/wikipedia/commons/6/68/Solid_black.png";
export const GOOGLE_MAPS_API_KEY = "AIzaSyATdCxRx5_ZgA2QOgQPz2BSGth-nmUu6mw";
